import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { Plant } from "@models/plant.model";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-plants-table',
    templateUrl: './plants-table.component.html',
    styleUrls: ['./plants-table.component.scss']
})
export class PlantsTableComponent {
    _logger = Log.create(PlantsTableComponent.name);

    @Input() plants = new Array<Plant>();
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() duplicateRow = new EventEmitter<any>();

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this._logger.info('onRowClick::', clickedItem);
        this.rowClick.emit(clickedItem);
    }

    onDuplicate(duplicate) {
        this._logger.info('onDuplicate::', duplicate);
        this.duplicateRow.emit(duplicate);
    }

}
